module.exports = __webpack_public_path__ + "static/media/story-2.65ce2393.jpg";